const COMPLETE = new Set(['completed', 'not_applicable']);

export const buildMissingDocsCanonicalSnapshot = ({ result, chainAnalysis, chainStatus, ecComparison, ecStatus }) => {
  if (!result || !COMPLETE.has(chainStatus) || !COMPLETE.has(ecStatus)) return null;
  return {
    schema_version: 1,
    status: 'complete',
    sections: {
      analysis: { status: 'completed', data: result },
      chain_analysis: { status: chainStatus, data: chainAnalysis || null, reason: chainStatus === 'not_applicable' ? 'The completed original analysis did not return a chain-of-title section.' : null },
      ec_reconciliation: { status: ecStatus, data: ecComparison || null, reason: ecStatus === 'not_applicable' ? 'No EC reconciliation was applicable to the completed original analysis.' : null },
    },
  };
};